import React, { Component } from "react";
import PropTypes from "prop-types";

import { ascending as d3Ascending } from "d3-array";
import { noop, strokeDashTypes } from "../../utils";
import { saveNodeType, isHover } from "../utils";
import { getXValue } from "../../utils/ChartDataUtil";

import StraightLine from "../components/StraightLine";
import ClickableCircle from "../components/ClickableCircle";
import HoverTextNearMouse from "../components/HoverTextNearMouse";
import GenericChartComponent from "../../GenericChartComponent";

class EachTrendLine extends Component {
  constructor(props) {
    super(props);

    this.handleEdge1Drag = this.handleEdge1Drag.bind(this);
    this.handleEdge2Drag = this.handleEdge2Drag.bind(this);
    this.handleLineDragStart = this.handleLineDragStart.bind(this);
    this.handleLineDrag = this.handleLineDrag.bind(this);

    this.handleEdge1DragStart = this.handleEdge1DragStart.bind(this);
    this.handleEdge2DragStart = this.handleEdge2DragStart.bind(this);

    this.handleDragComplete = this.handleDragComplete.bind(this);

    this.handleHover = this.handleHover.bind(this);

    this.isHover = isHover.bind(this);
    this.saveNodeType = saveNodeType.bind(this);
    this.nodes = {};

    this.state = {
      hover: false,
    };
  }
  handleLineDragStart() {
    const { x1Value, y1Value, x2Value, y2Value } = this.props;

    this.dragStart = {
      x1Value,
      y1Value,
      x2Value,
      y2Value,
    };
  }
  handleLineDrag(moreProps) {
    const { index, onDrag } = this.props;

    const { x1Value, y1Value, x2Value, y2Value } = this.dragStart;

    const {
      xScale,
      chartConfig: { yScale },
      xAccessor,
      fullData,
    } = moreProps;
    const { startPos, mouseXY } = moreProps;

    const x1 = xScale(x1Value);
    const y1 = yScale(y1Value);
    const x2 = xScale(x2Value);
    const y2 = yScale(y2Value);

    const dx = startPos[0] - mouseXY[0];
    const dy = startPos[1] - mouseXY[1];

    const newX1Value = getXValue(
      xScale,
      xAccessor,
      [x1 - dx, y1 - dy],
      fullData,
    );
    const newY1Value = yScale.invert(y1 - dy);
    const newX2Value = getXValue(
      xScale,
      xAccessor,
      [x2 - dx, y2 - dy],
      fullData,
    );
    const newY2Value = yScale.invert(y2 - dy);

    onDrag(index, {
      x1Value: newX1Value,
      y1Value: newY1Value,
      x2Value: newX2Value,
      y2Value: newY2Value,
    });
  }
  handleEdge1DragStart() {
    this.setState({
      anchor: "edge2",
    });
  }
  handleEdge2DragStart() {
    this.setState({
      anchor: "edge1",
    });
  }
  handleDragComplete(...rest) {
    this.setState({
      anchor: undefined,
    });
    this.props.onDragComplete(...rest);
  }
  handleEdge1Drag(moreProps) {
    const { index, onDrag } = this.props;
    const { x2Value, y2Value } = this.props;

    const [x1Value, y1Value] = getNewXY(moreProps);

    onDrag(index, {
      x1Value,
      y1Value,
      x2Value,
      y2Value,
    });
  }
  handleEdge2Drag(moreProps) {
    const { index, onDrag } = this.props;
    const { x1Value, y1Value } = this.props;

    const [x2Value, y2Value] = getNewXY(moreProps);

    onDrag(index, {
      x1Value,
      y1Value,
      x2Value,
      y2Value,
    });
  }
  handleHover(moreProps) {
    if (this.state.hover !== moreProps.hovering) {
      this.setState({
        hover: moreProps.hovering,
      });
    }
  }
  render() {
    const {
      x1Value,
      y1Value,
      x2Value,
      y2Value,
      type,
      stroke,
      strokeWidth,
      strokeOpacity,
      strokeDasharray,
      r,
      edgeFill,
      edgeStroke,
      edgeInteractiveCursor,
      lineInteractiveCursor,
      hoverText,
      selected,
      labelFont,

      onDragComplete,
    } = this.props;

    const {
      enable: hoverTextEnabled,
      selectedText: hoverTextSelected,
      text: hoverTextUnselected,
      ...restHoverTextProps
    } = hoverText;

    const { hover, anchor } = this.state;

    // Calculate bar count for LINE type
    const barCount =
      type === "LINE" ? Math.abs(Math.round(x2Value - x1Value)) : null;

    return (
      <g>
        <StraightLine
          ref={this.saveNodeType("line")}
          selected={selected || hover}
          onHover={this.handleHover}
          onUnHover={this.handleHover}
          x1Value={x1Value}
          y1Value={y1Value}
          x2Value={x2Value}
          y2Value={y2Value}
          type={type}
          stroke={stroke}
          strokeWidth={hover || selected ? strokeWidth + 1 : strokeWidth}
          strokeOpacity={strokeOpacity}
          strokeDasharray={strokeDasharray}
          interactiveCursorClass={lineInteractiveCursor}
          onDragStart={this.handleLineDragStart}
          onDrag={this.handleLineDrag}
          onDragComplete={onDragComplete}
        />
        <ClickableCircle
          ref={this.saveNodeType("edge1")}
          show={selected || hover}
          cx={x1Value}
          cy={y1Value}
          r={r}
          fill={edgeFill}
          stroke={anchor === "edge1" ? stroke : edgeStroke}
          strokeWidth={edgeStroke && edgeStroke.width ? edgeStroke.width : 2}
          strokeOpacity={1}
          interactiveCursorClass={edgeInteractiveCursor}
          onDragStart={this.handleEdge1DragStart}
          onDrag={this.handleEdge1Drag}
          onDragComplete={this.handleDragComplete}
        />
        <ClickableCircle
          ref={this.saveNodeType("edge2")}
          show={selected || hover}
          cx={x2Value}
          cy={y2Value}
          r={r}
          fill={edgeFill}
          stroke={anchor === "edge2" ? stroke : edgeStroke}
          strokeWidth={edgeStroke && edgeStroke.width ? edgeStroke.width : 2}
          strokeOpacity={1}
          interactiveCursorClass={edgeInteractiveCursor}
          onDragStart={this.handleEdge2DragStart}
          onDrag={this.handleEdge2Drag}
          onDragComplete={this.handleDragComplete}
        />
        <HoverTextNearMouse
          show={hoverTextEnabled && hover}
          {...restHoverTextProps}
          text={selected ? hoverTextSelected : hoverTextUnselected}
        />
        {barCount !== null && (
          <GenericChartComponent
            svgDraw={({ xScale, chartConfig: { yScale } }) => {
              const x1 = xScale(x1Value);
              const y1 = yScale(y1Value);
              const x2 = xScale(x2Value);
              const y2 = yScale(y2Value);

              // Calculate center position
              const centerX = (x1 + x2) / 2;
              const centerY = (y1 + y2) / 2;

              // Calculate price difference and percentage
              const priceDiff = y2Value - y1Value;
              const pricePercent = ((priceDiff / y1Value) * 100).toFixed(2);
              const priceSign = priceDiff >= 0 ? "+" : "";

              const text = `${barCount} barras | ${priceSign}${priceDiff.toFixed(2)} (${priceSign}${pricePercent}%)`;

              // Get font properties from labelFont appearance or use defaults
              const fontSize = labelFont?.fontSize ?? 12;
              const fontFamily =
                labelFont?.fontFamily ?? "system-ui, -apple-system, sans-serif";
              const fontColor = labelFont?.color ?? "#ffffff";

              const padding = 4;

              // Measure text (approximate)
              const textWidth = text.length * fontSize * 0.55;
              const textHeight = fontSize + padding * 3;
              const balloonWidth = textWidth + padding * 4;
              const balloonHeight = textHeight;

              // Calculate line angle to determine best label position
              const lineAngle = Math.atan2(y2 - y1, x2 - x1);
              const angleDegrees = (lineAngle * 180) / Math.PI;
              const isUpward = angleDegrees > -45 && angleDegrees < 45;

              // Calculate line length in screen coordinates
              const lineLength = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);

              // Calculate perpendicular offset - perpendicular to the line
              const perpendicularAngle = lineAngle + Math.PI / 2;

              // Calculate the minimum perpendicular distance needed:
              // Project the balloon's half-width onto the perpendicular direction
              // to find how far we need to shift to clear the line
              const halfLineLength = lineLength / 2;
              const balloonRadius =
                Math.sqrt(balloonWidth ** 2 + balloonHeight ** 2) / 2;

              // If the balloon radius is larger than half the line length,
              // we need extra perpendicular distance to avoid endpoints
              const basePerpendicular = 25; // Base distance for comfortable spacing
              let perpendicularShift = basePerpendicular;

              if (balloonRadius > halfLineLength) {
                // Calculate additional distance needed using Pythagorean theorem
                // We need: sqrt(balloonRadius² - halfLineLength²) additional distance
                const additionalDistance = Math.sqrt(
                  Math.max(0, balloonRadius ** 2 - halfLineLength ** 2),
                );
                perpendicularShift =
                  basePerpendicular + additionalDistance + 10; // +10px safety
              }

              // Calculate perpendicular shift components
              const horizontalShift =
                Math.cos(perpendicularAngle) * perpendicularShift;
              const verticalShift =
                Math.sin(perpendicularAngle) * perpendicularShift;

              // Apply perpendicular shift to center
              const shiftedCenterX = centerX + horizontalShift;
              const shiftedCenterY = centerY + verticalShift;

              // Additional vertical offset for upward/downward positioning
              const additionalVerticalOffset = 10;
              const finalBalloonY = isUpward
                ? shiftedCenterY - balloonHeight / 2 - additionalVerticalOffset
                : shiftedCenterY - balloonHeight / 2 + additionalVerticalOffset;

              const balloonX = shiftedCenterX - balloonWidth / 2;

              const tailSize = 6;

              return (
                <g>
                  {/* Balloon shadow */}
                  <rect
                    x={balloonX + 2}
                    y={finalBalloonY + 2}
                    width={balloonWidth}
                    height={balloonHeight}
                    fill="rgba(0, 0, 0, 0.3)"
                    rx={6}
                    filter="blur(3px)"
                  />

                  {/* Balloon tail (pointer) */}
                  <path
                    d={
                      isUpward
                        ? `M ${shiftedCenterX - tailSize},${finalBalloonY + balloonHeight} 
										   L ${centerX},${centerY - 5} 
										   L ${shiftedCenterX + tailSize},${finalBalloonY + balloonHeight} Z`
                        : `M ${shiftedCenterX - tailSize},${finalBalloonY} 
										   L ${centerX},${centerY + 5} 
										   L ${shiftedCenterX + tailSize},${finalBalloonY} Z`
                    }
                    fill="rgba(30, 30, 30, 0.95)"
                    stroke="rgba(255, 255, 255, 0.2)"
                    strokeWidth={0.5}
                  />

                  {/* Balloon background */}
                  <rect
                    x={balloonX}
                    y={finalBalloonY}
                    width={balloonWidth}
                    height={balloonHeight}
                    fill="rgba(30, 30, 30, 0.95)"
                    stroke="rgba(255, 255, 255, 0.2)"
                    strokeWidth={1}
                    rx={6}
                  />

                  {/* Balloon text */}
                  <text
                    x={shiftedCenterX}
                    y={finalBalloonY + balloonHeight / 2 + fontSize / 3}
                    textAnchor="middle"
                    fontSize={fontSize}
                    fill={fontColor}
                    fontWeight="500"
                    style={{ fontFamily: fontFamily }}
                  >
                    {text}
                  </text>
                </g>
              );
            }}
          />
        )}
      </g>
    );
  }
}

export function getNewXY(moreProps) {
  const {
    xScale,
    chartConfig: { yScale },
    xAccessor,
    plotData,
    mouseXY,
  } = moreProps;
  const mouseY = mouseXY[1];

  const x = getXValue(xScale, xAccessor, mouseXY, plotData);

  const [small, big] = yScale.domain().slice().sort(d3Ascending);
  const y = yScale.invert(mouseY);
  const newY = Math.min(Math.max(y, small), big);

  return [x, newY];
}

EachTrendLine.propTypes = {
  x1Value: PropTypes.any.isRequired,
  x2Value: PropTypes.any.isRequired,
  y1Value: PropTypes.any.isRequired,
  y2Value: PropTypes.any.isRequired,

  index: PropTypes.number,

  type: PropTypes.oneOf([
    "XLINE", // extends from -Infinity to +Infinity
    "RAY", // extends to +/-Infinity in one direction
    "LINE", // extends between the set bounds
  ]).isRequired,

  onDrag: PropTypes.func.isRequired,
  onEdge1Drag: PropTypes.func.isRequired,
  onEdge2Drag: PropTypes.func.isRequired,
  onDragComplete: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onUnSelect: PropTypes.func.isRequired,

  r: PropTypes.number.isRequired,
  strokeOpacity: PropTypes.number.isRequired,
  defaultClassName: PropTypes.string,

  selected: PropTypes.bool,

  stroke: PropTypes.string.isRequired,
  strokeWidth: PropTypes.number.isRequired,
  strokeDasharray: PropTypes.oneOf(strokeDashTypes),

  edgeStroke: PropTypes.shape({
    color: PropTypes.string,
    dash: PropTypes.string,
    width: PropTypes.number,
    opacity: PropTypes.number,
  }).isRequired,
  edgeInteractiveCursor: PropTypes.string.isRequired,
  lineInteractiveCursor: PropTypes.string.isRequired,
  edgeFill: PropTypes.string.isRequired,
  hoverText: PropTypes.object.isRequired,
  labelFont: PropTypes.shape({
    fontFamily: PropTypes.string,
    fontSize: PropTypes.number,
    color: PropTypes.string,
  }),
};

EachTrendLine.defaultProps = {
  onDrag: noop,
  onEdge1Drag: noop,
  onEdge2Drag: noop,
  onDragComplete: noop,
  onSelect: noop,
  onUnSelect: noop,

  selected: false,

  edgeStroke: { color: "#000000", dash: "Solid", width: 2, opacity: 1 },
  edgeFill: "#FFFFFF",
  r: 5,
  strokeWidth: 1,
  strokeOpacity: 1,
  strokeDasharray: "Solid",
  hoverText: {
    enable: false,
  },
};

export default EachTrendLine;
